/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";
import getSchema from "../../lib/api/getSchema";

/**
 * @COMPONENT_NAME CommonCodeView
 * @DESCRIPTION 공통코드 조회를 위한 화면입니다.
 *
 * @PROPS
      - 없음
 * @CALLBACKS
 *	  - {Function} onApiInitialized - API 초기화 시 호출되는 콜백 함수
 */
function CommonCodeView(props) {
	const { t } = useTranslation();
	const table = "VwCommonCodeView";
	const view = "VwCommonCodeView";

	const [schema, setSchema] = useState();
	const [api, setApi] = useState();

	useEffect(() => {
		let mounted = true;

		async function schemaSetting() {
			let schema = await getSchema(table);

			if (mounted) {
				setSchema(schema);
			}
		}

		schemaSetting();
		return () => {
			mounted = false;
		};
	}, []);

	useEffect(() => {
		if (api) api.refresh();
	}, [schema]);

	const onApiInitialized = (api) => {
		setApi(api);
	};

	return (
		<BasicCrudScreenType
			id={table}
			headerTitle={t("term.commonCodeView")}
			table={table}
			view={view}
			noCreate
			noEdit
			noDelete
			noExcel
			onApiInitialized={onApiInitialized}
		/>
	);
}

export default CommonCodeView;
